<template>
    <div class="question_bank" :class="{'hidPadding': !$store.state.headShow}">
        <Head v-show="$store.state.headShow" :showTab="false" activeMenu="同同K题" :showSubject="showSubject"></Head>
        <div class="question_bank_container">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import Head from '../components/Head'
    export default {
        name: "QuestionBank",
        data () {
            return {
                showSubject: false,
            }
        },
        mounted () {
            document.title = '同同K题 | 学校大脑';
            this.$store.dispatch('contextHead', false);
        },
        components: {
            Head
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    .question_bank{
        height: 100%;
        padding-top: 60px;
        box-sizing: border-box;
        .question_bank_container{
            height: 100%;
            box-sizing: border-box;
            overflow: hidden;
        }
    }
    .hidPadding{
        padding-top: 0;
    }
</style>
